import { DataBrowser } from "@/components/DataBrowser";
import { Database } from "lucide-react";

export default function SystemDataViewer() {
  return (
    <div className="space-y-4" data-testid="portal-system-data">
      <div className="bg-white/[0.035] border border-[#67F2B3]/12 rounded-2xl p-5">
        <div className="flex items-center gap-2 mb-1">
          <Database className="h-4 w-4 text-[#67F2B3]" />
          <span className="font-heading font-semibold">Your project data</span>
        </div>
        <p className="text-sm text-[#F4FFF9]/55">A read-only view of the data snapshots ECOREXS has prepared for your project. Browse records, search and inspect details. This is a secure snapshot — not a live production database.</p>
      </div>
      <DataBrowser
        dark
        listPath="/portal/datasets"
        recordsPath={(id) => `/portal/datasets/${id}/records`}
      />
    </div>
  );
}
